import { Box, Button, Dialog, DialogActions, DialogContent, Divider, Grid, IconButton, LinearProgress, SelectChangeEvent, useTheme, Skeleton, Theme, Typography, Tooltip } from '@mui/material';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import { Formik, FormikProps, useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
  Distributor,
  getLocationList,
  getRMsList,
  SubDistributor,
} from '../../redux-store/actions';
import React, { useEffect, useRef, useState } from 'react';
import { RootStateType } from '../../redux-store/reducers';
import { updateApplication } from '../../redux-store/actions/application';
import { useHistory, useRouteMatch } from 'react-router';
import { AMC_APPROVER_CHECK_FOR_INDIVIDUAL, MPOWER_ACCOUNT_TYPE_MASTER, PHYSICAL_DIGITAL_FLOW, ROLE_GROUP, ROLE_TYPE, SUBROLE, USER_ROLES } from '../../utils/constant';
import { ProceedSaveLater } from './components';
import {
  applicationComparison,
  applyRoleBasedStatus,
  isModuleAllowed,
  saveForLater,
  sendRoleBasedStatus,
} from '../../utils/utilityFunctions';
import { GetTaggedRmListResponseBody, RMType, SupportRmProp, TaggedRmObject } from '../../redux-store/types/api-types';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { distributorsValidationSchema } from '../../utils/schema';
import MFSelectField from '../../lib/formik/SelectField';
import { LocationType, mdmsLocationList } from '../../redux-store/types/mdms';
import { showError } from '../../redux-store/actions/auth';
import { getRMById, getRMByIwappRmId, getTaggedRmList } from '../../redux-store/actions/userManagement';
import { CountryCodesDropDown } from '../commonComponents';
import MFCheckbox from '../../lib/formik/Checkbox';
import CloseIcon from '@mui/icons-material/Close';
import theme from '../../themes';

interface TaggedRM extends TaggedRmObject {
  key: string;
  value: string | number
}

type DistributorDetailsProps = {
  firstName: string;
  phone: any;
  email: string;
  saveType: string;
  rm_id: number | null | undefined;
  location: string | null;
  isBSEEnabled?: boolean;
  isEsignEnabled?: boolean;
  currentRM?: any;
  taggedRmId: TaggedRM | null;
  segment: string;
  subBrokerCode?: string;
  subSegment?: string;
};

function GridItem({ children }: { children: React.ReactNode }) {
  return (
    <Grid item xs={12} lg={6}>
      {children}
    </Grid>
  );
}

const RMDetail = ({
  isSupportRM,
  rmsList,
  values,
  locationMaster,
  taggedRmArray,
  isRspGroup,
  isSubBrk
}: {
  isSupportRM: boolean;
  rmsList: any;
  values: any;
  locationMaster: mdmsLocationList[];
  taggedRmArray: TaggedRM[];
  isRspGroup: boolean;
  isSubBrk: boolean
}) => {
  const [mobileElementWidth, setMobileElementWidth] = useState(null);
  const { setValues: formikSetValues } = useFormikContext();

  useEffect(() => {
    const mobileElement = document.getElementsByName('phone');
    setMobileElementWidth(mobileElement[0]?.parentElement?.clientWidth as any);
  }, []);

  const rmsListSorting = [...rmsList].sort((a, b) => (a.name > b.name ? 1 : -1));
  const selectedRm = rmsList.find((item: SupportRmProp) => item.id === values.rm_id);

  const selectedTaggedRm: any = isRspGroup ? taggedRmArray.find(rm => rm.value === values.taggedRmId?.value) : (taggedRmArray.length > 0 ? taggedRmArray[0] : {});
  const subBrokerOptions = selectedTaggedRm?.subBrokers?.map((sb: any) => ({ key: sb.subBrokerCode, value: sb.subBrokerCode })) || [];
  const handleSubbroker = (event: SelectChangeEvent<unknown>) => {
    const selectedSubBrokerCode = event.target.value as string;
    formikSetValues({
      ...values,
      subBrokerCode: selectedSubBrokerCode,
      subSegment: selectedTaggedRm?.subSegment ?? ''
    });
  };

  return (
    <>
      <GridItem>
        <MFTextField
          name="firstName"
          label={isSupportRM ? "Service RM's Name" : "RM's Name"}
          placeholder="Enter RM name"
          disabled={true}
          value={values.firstName ?? ""}
        />
      </GridItem>
      <GridItem>
        <MFTextField
          name="rmsegment"
          label="Segment"
          placeholder="Enter RM Segment"
          disabled={true}
          value={values.segment ?? ""}
        />
      </GridItem>
      <GridItem>
        <Box sx={{ position: 'relative' }}>
          <MFSelectField
            name="subBrokerCode"
            label="SubBrokerCode"
            placeholder="Select SubBrokerCode"
            items={subBrokerOptions}
            value={values.subBrokerCode ?? ""}
            onChange={handleSubbroker}
            disabled={isRspGroup && !selectedTaggedRm || subBrokerOptions.length === 0 || isSubBrk}
          />
          {values.subBrokerCode && (
            <Tooltip title="You can also Un-Select SubBrokerCode">
              <IconButton
                onClick={() => formikSetValues({ ...values, subBrokerCode: '', subSegment: '' })}
                sx={{
                  position: 'absolute',
                  right: 25,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: theme.palette.text.secondary,
                }}
                disabled={isSubBrk}
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </GridItem>
      {values.subBrokerCode && (
        <GridItem>
          <MFTextField
            name="subSegment"
            label="SubSegment"
            placeholder="Enter SubBroker SegmentCode"
            disabled={true}
            value={values.subSegment ?? ""}
          />
        </GridItem>
      )}
      <GridItem>
        <MFTextField
          name="email"
          label={isSupportRM ? "Service RM's Email Address" : "RM's Email Address"}
          placeholder="Enter RM Email ID"
          disabled={true}
          value={values.email ?? ""}
        />
      </GridItem>
      <GridItem>
        <MFTextField
          name="phone"
          label={isSupportRM ? "Service RM's Mobile Number" : "RM's Mobile Number"}
          placeholder="Enter Mobile Number"
          disabled={true}
          value={values?.phone?.split(" ")?.[1] ?? ""}
          startAdornment={
            <CountryCodesDropDown
              ElementWidth={mobileElementWidth && mobileElementWidth}
              name="phone"
              value={values?.phone?.split(" ")?.[0] ?? ""}
              disabled={true}
            />
          }
        />
      </GridItem>
      {/* <GridItem> */}
      {/* <MFSelectField
          name={`location`}
          label={'Location'}
          items={locationMaster.map((location) => ({
            key: location.value,
            value: location.key,
          }))}
          disabled
          value={values.location ?? ""}
        /> */}
      {/* <MFTextField
          name={`location`}
          label={'Location'}
          placeholder="Enter Location"
          disabled
          value={values.location ?? ""}
        />
      </GridItem> */}
      {!rmsList.length && isSupportRM && (
        <GridItem>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              height: '100%',
              width: '100%',
              mt: 10,
            }}>
            <Typography
              sx={{
                fontSize: 18,
                fontWeight: 500,
                color: 'rgb(97, 209, 214)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: '7%',
              }}>
              {`AMC's RM is Not Available`}
            </Typography>
          </Box>
        </GridItem>
      )}
      {isSupportRM && rmsList?.length > 0 && (
        <>
          <GridItem>
            <SearchableSelect
              name="rm_id"
              label="RM's Name*"
              items={rmsListSorting.sort().map((item: SupportRmProp) => ({
                key: item.name,
                value: item.id,
              }))}
              searchFieldPlaceholder={'Search RM'}
            />
          </GridItem>
          {values.rm_id && (
            <>
              <GridItem>
                <MFTextField
                  name="amcEmail"
                  label="RM's Email ID"
                  placeholder="Enter RM's Email ID"
                  value={selectedRm?.user?.email}
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="amcMobile"
                  label="RM's Mobile Number"
                  placeholder="Enter RM's Mobile Number"
                  value={selectedRm?.user?.phone}
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFSelectField
                  name={`amcLocation`}
                  label="Location"
                  items={locationMaster.map((location) => ({
                    key: location.value,
                    value: location.key,
                  }))}
                  value={selectedRm?.location}
                  disabled={true}
                />
              </GridItem>
            </>
          )}
        </>
      )}
    </>
  );
};

export default function DistributorDetails(): JSX.Element {
  const dispatch = useDispatch();
  const history = useHistory();
  const theme = useTheme();
  const { path: currentPath } = useRouteMatch();
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role, userDetails, subRole = '', roleGroup = '', isBaseRM } = useSelector((store: RootStateType) => store.auth);
  const { rm, rm_id, supportRm, support_rm_id } = application || {};
  const { auth } = useSelector((store: RootStateType) => store);
  const [open, setOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');
  const [currentFlag, setCurrentFlag] = useState<string | null>(null);
  const [rmsDropdwn, setRmsDropdwn] = useState<Array<{ key: string; value: string | number }>>([]);

  const [taggedRmArray, setTaggedRmArray] = useState<Array<TaggedRM>>([])
  const [rmsList, setRmList] = useState<RMType[]>([]);
  const [locationMaster, setLocationMaster] = useState<mdmsLocationList[]>([]);

  const formikRef = useRef<FormikProps<DistributorDetailsProps>>(null);

  const isDiyInvestorOnboarding = currentPath?.includes("/investor-onboarding-application")

  const isSupportRM = isDiyInvestorOnboarding ? false : auth.id === application?.supportRm?.userId;
  const { onboardingVia, accountType, applicationType } = application || {};

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [rmsLoading, setRmsLoading] = useState<boolean>(false);
  const [isStatusCheck, setStatusCheck] = useState<boolean>(false);

  const {
    user: { email: RMEmail = '', firstName: RMFirstName = '', phone, countryCode },
    branchName: RMLocation = '',
  } = (isSupportRM ? supportRm : rm) || { empCode: '', user: { email: '' } };
  const bseEnabledCheck = application?.applicationType === 'non_individual' ? (`${application?.applicants?.[0]?.kraVerified ?? ''}`.toLowerCase() === 'yes') : (!!application?.applicants?.[0]?.panAadharCheck && `${application?.applicants?.[0]?.kraVerified ?? ''}`.toLowerCase() === 'yes');

  const selectedTaggedRmObj = (taggedRmArray ?? []).find(obj => `${obj?.value ?? ""}` === `${application?.taggedRmId ?? ""}`)

  const getPhoneData = (countryCode: string, phone: string) => {
    return countryCode ? countryCode + ' ' + phone : phone
  }

  const isRspGroup = [ROLE_GROUP.RSP].includes(roleGroup);
  const isSubBrk = [SUBROLE.SUB_BRK].includes(`${subRole ?? ''}`.toUpperCase() as SUBROLE);

  const initialValues: DistributorDetailsProps = {
    email: application?.taggedRmId ? (selectedTaggedRmObj?.email ?? "") : (RMEmail ?? ""),
    firstName: application?.taggedRmId ? (selectedTaggedRmObj?.name ?? "") : (RMFirstName ?? ""),
    phone: application?.taggedRmId ? getPhoneData(selectedTaggedRmObj?.countryCode ?? "", selectedTaggedRmObj?.phone ?? "") : getPhoneData(countryCode ?? "", phone ?? ""),
    saveType: 'save and proceed',
    rm_id,
    location: application?.taggedRmId ? (selectedTaggedRmObj?.branchName ?? "") : (RMLocation ?? ""),
    ...(PHYSICAL_DIGITAL_FLOW ? {
      // isBSEEnabled: (application?.isBSEEnabled ?? bseEnabledCheck),
      isBSEEnabled: application?.isBSEEnabled ?? false,
      isEsignEnabled: application?.isEsignEnabled ?? applicationType !== 'non_individual',
      currentRM: rmsDropdwn.find(rm => rm.value === application?.rm_id)?.value ?? ''
    } : {}),
    taggedRmId: selectedTaggedRmObj ?? null,
    segment: application?.taggedRmId ? (selectedTaggedRmObj?.segment ?? '') : (rm?.segment ?? ''),
    subBrokerCode: application?.subBrokerCode ?? "",
    subSegment: !application?.subBrokerCode ? "" :
      application?.taggedRmId ? (selectedTaggedRmObj?.subSegment ?? '') : "",
    // currentRM: application?.rm_id ?? '',
  };

  const getRmsData = async () => {
    setRmsLoading(true);

    const rmsListRes = (await dispatch(getRMByIwappRmId(userDetails?.iwappRmId)) as unknown as RMType[]);

    setRmsDropdwn(rmsListRes?.map(rm => ({
      key: rm.name ?? '',
      value: rm.id ?? ''
    })))
  }

  const fetchTaggedRmList = async () => {
    const response = await (dispatch(getTaggedRmList()) as unknown as Promise<GetTaggedRmListResponseBody>)
    return response;
  }

  useEffect(() => {
    (async function () {
      try {
        setRmsLoading(true);

        const taggedRMRes = await fetchTaggedRmList();
        const modifiedTaggedRmRes = (taggedRMRes?.rmList ?? []).map((obj: TaggedRmObject) => ({
          ...obj,
          key: obj?.name ?? '',
          value: obj?.id
        }))
        setTaggedRmArray(() => {
          return modifiedTaggedRmRes;
        });

        PHYSICAL_DIGITAL_FLOW && [USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.OPM].includes(role) && userDetails?.userRole !== "REX" && await getRmsData()

        let updateRMList: RMType[] = [];
        const locations = (await dispatch(getLocationList())) as unknown as LocationType;
        setLocationMaster(locations.rmLocationList);
        if (isSupportRM) {
          const listedRM = ((await dispatch(getRMById(Number(support_rm_id)))) as unknown as RMType)
            ?.amcRmDetails;
          updateRMList =
            application?.rm_id &&
              (!application.rm.isActive || !listedRM?.amcRmIds.includes(`${application?.rm_id}`))
              ? [...(listedRM?.amcRms || []), application?.rm]
              : listedRM?.amcRms || [];
        }
        setRmList(updateRMList);
        setStatusCheck(!!application?.isBSEEnabled);
        setRmsLoading(false);
        isSubBrk && await handleTaggedRmChange(modifiedTaggedRmRes?.[0]);
        // setStatusCheck(application?.applicationType === 'non_individual' ? `${application?.applicants?.[0]?.kraVerified ?? ''}`.toLowerCase() === 'yes' : !!application?.applicants?.[0]?.panAadharCheck && `${application?.applicants?.[0]?.kraVerified ?? ''}`.toLowerCase() === 'yes');

      } catch (e: unknown) {
        console.error((e as Error).message);
      }
      finally {
        setRmsLoading(false);
      }
    })();
  }, [application]);

  const onSubmit = async (values: DistributorDetailsProps) => {
    try {
      setIsLoading(true)

      if (!rmsList.length && isSupportRM) {
        throw `AMC's RM is Not Available`;
      }
      const { saveType } = values;
      const { id, applicant1ReferenceId, currentStep = null, status, hasPOA } = application || {};
      const checkApplication = applicationComparison(application, {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ...application!,
        currentStep: currentStep === null ? 1 : currentStep,
        ...(PHYSICAL_DIGITAL_FLOW ? {
          rm_id: values.currentRM,
          isBSEEnabled: values.isBSEEnabled,
          isEsignEnabled: values.isEsignEnabled,
        } : {
          rm_id: values.rm_id
        }),
        taggedRmId: !isRspGroup ? taggedRmArray?.[0].id : values?.taggedRmId?.value ?? null
      });
      if (id && !checkApplication) {
        const response = await dispatch(
          updateApplication({
            body: {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              ...application!,
              // onboardingVia: values?.isEsignEnabled ? 'digital' : 'physical',
              onboardingVia: 'digital',
              // status:
              //   !hasPOA &&
              //     AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
              //     status !== 'draft' &&
              //     applyRoleBasedStatus(role)
              //     ? 'sent_to_amc_approver'
              //     : status,
              status: sendRoleBasedStatus(role, status as string),
              currentStep: 1,
              // rm_id: values.currentRM,
              ...(PHYSICAL_DIGITAL_FLOW ? {
                rm_id: isBaseRM ? rm_id : (values.currentRM || rm_id),
                isBSEEnabled: values.isBSEEnabled,
                isEsignEnabled: values.isEsignEnabled,
              } : {
                rm_id: values.rm_id,
              }),
              taggedRmId: !isRspGroup ? taggedRmArray?.[0].id : values?.taggedRmId?.value ?? null,
              // segment: values.segment,
              subBrokerCode: values.subBrokerCode,
              // subSegment: values.subSegment,
              // segment: values.segment
              //currentStep === null ? 1 : currentStep
              // filledBy,
            },
            applicationId: id,
          })
        );

        if (!response) {
          setIsLoading(false);
          return;
        }

        saveType === 'save and proceed'
          ? history.push('personal-details', { id, applicant1ReferenceId })
          : history.push(saveForLater(role, id, applicant1ReferenceId));
      } else if (checkApplication) {
        saveType === 'save and proceed'
          ? history.push('personal-details', { id, applicant1ReferenceId })
          : history.push(saveForLater(role, id, applicant1ReferenceId));
      }
      saveType === 'save and proceed'
        ? history.push('personal-details', { id, applicant1ReferenceId })
        : history.push(saveForLater(role, id, applicant1ReferenceId));
    } catch (e) {
      typeof e === 'string' && dispatch(showError(e as string));
      console.error((e as Error).message);
    } finally {
      setIsLoading(false)
    }
  };

  const handleCheckboxCheck = (type: string, checked: boolean) => {
    setOpen(true)
    setCurrentFlag(type);
    if (type === 'bse') {
      setMessage(`Do you want to ${checked ? 'enable' : 'disable'} BSE?`)
    }
    else {
      setMessage(`Do you want to ${checked ? 'enable' : 'disable'} E-Sign?`)
    }
  }

  const handleDialogSave = (setValues: any, values: any) => {
    if (currentFlag === 'bse') {
      setValues({
        ...values,
        isBSEEnabled: !values.isBSEEnabled
      });
    } else if (currentFlag === 'esign') {
      setValues({
        ...values,
        isEsignEnabled: !values.isEsignEnabled
      });
    }
    setOpen(false);
  }

  const handleTaggedRmChange = async (obj: TaggedRM | null) => {
    await formikRef?.current?.setValues((prevValues) => ({
      ...prevValues,
      taggedRmId: obj ?? null,
      firstName: obj?.name ?? "",
      email: obj?.email ?? "",
      phone: getPhoneData(obj?.countryCode ?? "", obj?.phone ?? ""),
      location: obj?.branchName ?? "",
      segment: obj?.segment ?? "",
      subBrokerCode: application?.subBrokerCode ? application?.subBrokerCode : isSubBrk ? application?.rm?.iwappRmId : '',
      subSegment: obj?.subSegment ?? '',
      // subSegment: (!application?.subBrokerCode || application.subBrokerCode === application?.subBrokerCode) ? "" : application?.taggedRmId ? (selectedTaggedRmObj?.subSegment ?? '') : "",
    }))
  }

  return (
    <>
      {rmsLoading && <LinearProgress />}
      {!rmsLoading && (
        <Formik
          innerRef={formikRef}
          initialValues={initialValues}
          validationSchema={distributorsValidationSchema(isSupportRM, rmsList, userDetails?.userRole, PHYSICAL_DIGITAL_FLOW, role, subRole, isRspGroup)}
          onSubmit={onSubmit}
          enableReinitialize={true}>
          {({ handleSubmit, values, setValues, errors }) => {
            return (
              <>
                <Box component="form" noValidate onSubmit={handleSubmit}>
                  <Grid container columnSpacing={3} rowSpacing={0.5}>
                    {/* {PHYSICAL_DIGITAL_FLOW && [USER_ROLES.RM].includes(role) && userDetails?.userRole !== "REX"  ![ROLE_TYPE.REL_M].includes(subRole) && ( )} */}
                    {/* {[USER_ROLES.RM].includes(role) && userDetails?.userRole !== "REX" && ![ROLE_TYPE.REL_M].includes(subRole) &&
                      <Grid item xs={12} lg={6} >
                        <SearchableSelect
                          name={`currentRM`}
                          // label="Current RM"
                          label="Select RM"
                          items={rmsDropdwn}
                          // items={nationalitiesMdmsResponse.map((nationality) => ({
                          //   key: nationality.name,
                          //   value: nationality.name,
                          // }))}
                          // disabled={isFieldDisabled}
                          searchFieldPlaceholder={'Search RM'}
                        />
                      </Grid>} */}
                    {(isRspGroup || isSubBrk) &&
                      <><Grid item xs={12} lg={6}>
                        <SearchableSelect
                          name="taggedRmId"
                          label="Tagged RM"
                          items={taggedRmArray}
                          searchFieldPlaceholder={'Search RM'}
                          disabled={rmsLoading || isSubBrk}
                          value={values?.taggedRmId?.value ?? ""}
                          onChange={(e) => {
                            const value = e.target.value ?? '';
                            const selectedObj = taggedRmArray?.find(obj => `${obj?.value ?? ""}` === `${value ?? ""}`)
                            return handleTaggedRmChange(selectedObj ?? null)
                          }}
                        />
                      </Grid>
                        {/* {userDetails?.userRole?.toLowerCase() === "rex" && ( */}
                        <Grid
                          item
                          xs={12}
                          lg={6}
                          sx={{
                            display: {
                              xs: 'none',
                              lg: 'block'
                            }
                          }}
                        /></>}
                    {/* )}  */}

                    <RMDetail
                      isSupportRM={isSupportRM}
                      rmsList={rmsList}
                      values={values}
                      locationMaster={locationMaster}
                      taggedRmArray={taggedRmArray}
                      isRspGroup={isRspGroup}
                      isSubBrk={isSubBrk}
                    />

                    {/* {PHYSICAL_DIGITAL_FLOW && (
                      <>
                        <Grid item xs={12}>
                          <Divider sx={{ color: 'red', mt: 2 }} />
                        </Grid>

                        <Grid item xs={12}>
                          <Typography variant='h2' mt={2}>Enable/Disable BSE</Typography>
                        </Grid>
                      </>
                    )} */}
                    {/* {PHYSICAL_DIGITAL_FLOW && (
                      <Grid item container mt={3}>
                        <Grid item xs={12} >
                          <MFCheckbox
                            name={`isBSEEnabled`}
                            label={`Do you want to invest in MF?`}
                            checked={values.isBSEEnabled}
                            sx={{ letterSpacing: '1px', width: 'fit-content' }}
                            onChange={(e) => handleCheckboxCheck('bse', e.target.checked)}
                            disabled={true}
                            // disabled={[USER_ROLES.AMCAPPROVER, USER_ROLES.INVESTOR].includes(role) || isExecutionary || isHeldAway}
                          />
                        {!rmsLoading && <Typography variant="body_400" color="error">{(isStatusCheck ?? true) ? "" : `KRA${application?.applicationType !== 'non_individual' ? '/Pan-Aadhaar Link' : ''} Failed, Can't send to BSE`}</Typography>}
                        {!rmsLoading && !values.isBSEEnabled && <Typography variant="body_400" color={theme.palette.common.lightBlack}>Investor won&apos;t be able to do MF Transactions</Typography>}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <MFCheckbox
                            name={`isEsignEnabled`}
                            label={`Is E-Sign Enabled`}
                            checked={values.isEsignEnabled}
                            sx={{ letterSpacing: '1px' }}
                            onChange={(e) => handleCheckboxCheck('esign', e.target.checked)}
                            // disabled={[USER_ROLES.AMCAPPROVER].includes(role)}
                            disabled={true}
                          />
                        </Grid>
                      </Grid>
                    )} */}


                    <Grid item xs={12} my={1} />
                    <ProceedSaveLater
                      saveLater={() => {
                        setValues({
                          ...values,
                          saveType: 'save for later',
                        });
                      }}
                      saveAndProceed={() => {
                        setValues({
                          ...values,
                          saveType: 'save and proceed',
                        });
                      }}
                      loader={isLoading}
                      clickedButton={values.saveType}
                      saveButtonText="Continue"
                      showEndIcon={false}
                    />
                  </Grid>
                </Box>
                <Dialog
                  onClose={setOpen}
                  open={open}
                  maxWidth='sm'
                  fullWidth
                  sx={{
                    '& .MuiPaper-root': {
                      borderRadius: '15px',
                      backgroundColor: "background.paper",
                      rowGap: "25px",
                    },
                  }}
                >
                  <DialogContent sx={{ paddingTop: "25px" }}>
                    <Box sx={{ display: "flex", columnGap: "8px" }}>
                      {/* {showIcon ? icon || <WarningIcon /> : null} */}
                      <Typography variant='h2' color="text.primary" mb="10px">{message}</Typography>
                    </Box>
                    {values.isBSEEnabled && <Typography variant='body_400' color="text.primary">Investor won&apos;t be able to do MF Transactions</Typography>}
                  </DialogContent>
                  <DialogActions sx={{ padding: "25px", columnGap: "10px" }}>
                    <Button
                      variant="outlined"
                      onClick={() => setOpen(false)}
                      sx={(theme: Theme) => ({
                        color: theme.palette.text.secondary,
                        flex: 1,
                        border: `0.5px solid ${theme.palette.text.secondary}`,
                        padding: "10px",
                        "&:hover, &.Mui-focusVisible": {
                          borderColor: theme.palette.text.secondary,
                          backgroundColor: theme.palette.background.default
                        }
                      })}
                    >
                      {'No'}
                    </Button>
                    <Button
                      variant="contained"
                      sx={(theme: Theme) => ({
                        flex: 1,
                        color: theme.palette.textDark.primary,
                        padding: "10px"
                      })}
                      onClick={() => handleDialogSave(setValues, values)}
                    >
                      {'Yes'}
                    </Button>
                  </DialogActions>
                </Dialog>
              </>
            )
          }
          }
        </Formik>
      )}
    </>
  );
}
